/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Button } from 'reactstrap'

import ReactTable from 'react-table-legacy'
import "react-table-legacy/react-table.css";

import {AppContext} from '../AppContext';

class SessionLimitExceeded extends React.Component
{
  async activateSession()
  {
    let result = await this.context.dbTwig.callRestAPI('icam', 'activateBlockedSession');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Unable to activate your session');
    if ('active' === result.jsonData.sessionStatus)
    {
      this.context.postNotification('info', 'Your session has been activated.');
      this.props.setSessionStatus(result.jsonData.sessionStatus);
    }
    else
      this.context.postNotification('warning', 'Sorry, your session is still blocked.');
  }

  componentDidMount()
  {
    this.fetchActiveSessions();
  }

  constructor(props)
  {
    super();

    this.state =
    {
      activeSessions: []
    }

    this.activateSession = this.activateSession.bind(this);
  }

  async fetchActiveSessions()
  {
    let bodyData = {}
    bodyData.sessionStatus = this.context.userSession.sessionInfo.sessionStatus;
    
    let result = await this.context.dbTwig.callRestAPI('icam', 'getActiveSessions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting active sessions');
    this.setState({activeSessions: result.jsonData.activeSessions});
  }

  render()
  {
    let columns = 
    [
      {Header: 'IP Address', id: 'ipAddress', accessor: 'clientAddress'},
      {Header: 'Session Created', id: 'sessionCreated', accessor: d => {return d.sessionCreated}, 
        Cell: rowInfo => (<div>{window.formatTimestamp(rowInfo.row.sessionCreated, true)}</div>)},
      {Header: 'Last Activity', id: 'lastActivity', accessor: d => {return d.lastActivity}, 
        Cell: rowInfo => (<div>{window.formatTimestamp(rowInfo.row.lastActivity, true)}</div>)},
      {Header: 'User Agent', id: 'userAgent', accessor: 'userAgent',
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Terminate Session', id: 'terminateSession', 
        Cell: (rowInfo) => 
        { 
          return (
            <div className="text-center">
              <Button className="btn-sm" color="secondary" onClick={this.terminateSession.bind(this, rowInfo)}>Terminate Session</Button>
            </div>
          );
        }},
      {accessor: 'sessionId', id: 'sessionId', show: false}
    ]
  
    return(
      <div>
        <h4>Attention: Your session is blocked. You have exceeded the number of active sessions allowed.</h4>
        <br />
        <h4>Here is a list of your active sessions.</h4>
        <br />
        <h4>You can end a browser sessions on one of your devices and then press the 'Activate Session' button.</h4>
        <br />
        <Button id="activateButton" color="primary" onClick={this.activateSession} >Activate Session</Button>
        <br />
        <h4>Or, you can terminate a session by pressing the 'Terminate Session' button but that will not save any changes you have made in the browser session.</h4>
        <br />
        <ReactTable data={this.state.activeSessions} showPagination={false} columns={columns} minRows={1} className="-highlight"/>
      </div>
    );
  }

  async terminateSession(rowInfo, event)
  {
    event.preventDefault();

    let bodyData = {};

    bodyData.sessionToTerminate = rowInfo.row.sessionId;

    let result = await this.context.dbTwig.callRestAPI('icam', 'abandonForCurrentSession', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error activating session');
    this.context.postNotification('info', 'Session activated.');
    this.props.setSessionStatus(result.jsonData.sessionStatus);
  }
}

SessionLimitExceeded.contextType = AppContext;

export default SessionLimitExceeded;